import Comment from './Comment';
import EllipsisText from './EllipsisText';
import HiddenText from './HiddenText';
import Text from './Text';

export { Text, HiddenText, EllipsisText, Comment };
export default Text;
